// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","textBlockWithIconRowSection":"textBlockWithIconRowSection_textBlockWithIconRowSection__UFFeE","icon":"textBlockWithIconRowSection_icon__Hy4dt"};